module.exports = __webpack_public_path__ + "img/m-fukuanshenqing.7c6c277c.svg";